// Environment-specific configuration
const currentHostname = window.location.hostname;
const currentProtocol = window.location.protocol;
const wsProtocol = currentProtocol === 'https:' ? 'wss:' : 'ws:';
const ENV = window.location.hostname.includes('localhost') ? 'development' : 'production';



const CONFIG = {
  development: {
    BASE_URL: 'http://localhost:3000', // Local proxy URL
    WSS_URL: 'wss://web-uat.velora.plus',   // WebSocket URL
    USE_PROXY: true,
    ASSETS_URL: '/',
  },
  staging: {
    BASE_URL: `${currentProtocol}//${currentHostname}`,
    WSS_URL: `${wsProtocol}//${currentHostname}`,
    USE_PROXY: false,
    ASSETS_URL: '/',
  },
  production: {
    BASE_URL: `${currentProtocol}//${currentHostname}`,
    WSS_URL: `${wsProtocol}//${currentHostname}`,
    USE_PROXY: false,
    ASSETS_URL: '/',
  }
};


export const API_CONFIG = {
  ...CONFIG[ENV],
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/v4/sign-in',
    VERIFY_2FA: '/api/v1/user/twofa',
    RESET_PASSWORD: '/api/v1/user/password/forgot',
    FORGOT_PASSWORD_OTP: '/api/v4/recovery/otp',
    SET_NEW_PASSWORD: '/api/v4/recovery',

    // Settings
    USER_SETTINGS: '/api/v1/account/preferences',
    BROKER_SETTINGS: '/api/v2/member/config',

    // Market Data
    MARKET_WATCH: '/api/v1/symbol-lists',
    ALL_INDICES: '/api/v1/indices',
    ADD_INSTRUMENT: '/api/v1/symbol-lists',
    DELETE_INSTRUMENT: '/api/v1/marketwatches/{id}',
    MARKET_DEPTH: '/api/v1/marketdepth/{token}',
    TICKER: '/api/v1/ticker/{exchange}/{segment}',    

    // Orders
    PLACE_ORDER: '/api/v1/order-book',
    MODIFY_ORDER: '/api/v1/orders/{order_id}',
    CANCEL_ORDER: '/api/v1/orders/{order_id}',
    ORDER_BOOK: '/api/v1/order-book',
    TRADE_BOOK: '/api/v1/fills',
    BRACKET_ORDER: '/api/v1/bracket-orders',
    BASKET_ORDER: '/api/v1/basket-orders',
    COVER_ORDER: '/api/v1/cover-orders',

    // Portfolio & Holdings
    POSITIONS: '/api/v1/open-positions',
    HOLDINGS: '/api/v1/holdings',

    // User Profile
    PROFILE: '/api/v1/account',
    CHANGE_PASSWORD: '/api/v1/user/password/change',
    REFERRAL_BONUS: '/api/v1/rewards',

    // Funds
    FUNDS: '/api/v2/funds/view',
    FUND_LIMITS: '/api/v1/funds/limits',
    FUNDS_TRANSACTIONS: '/api/v1/ledger/movements',

    // Websocket
    WEBSOCKET: '/api/v1/feed',

    // Instruments
    SEARCH_INSTRUMENTS: '/api/v1/search',
    INSTRUMENT_INFO: '/api/v1/contract',
    DASHBOARD_PINS: '/api/v1/favorites'
  }
};

export const getApiUrl = (endpoint) => {
  const config = CONFIG[ENV];
  return config.USE_PROXY ? endpoint : `${config.BASE_URL}${endpoint}`;
};

export const createAuthHeader = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

export const getAssetUrl = (assetPath) => {
  const config = CONFIG[ENV];
  return `${config.BASE_URL}/${assetPath}`;
}; 